import * as React from 'react';
import Logo from '../../../assets/SVG/nexxt-logo';
import { Link } from 'react-router-dom';
import { WORKSPACE } from '../../../constants/routes';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
interface PageNotSupportedOnMobileProps {
    toggleIsSupportedOnMobile?: (toggle: boolean) => void;
}

const PageNotSupportedOnMobile: React.FC<PageNotSupportedOnMobileProps> = ({
    toggleIsSupportedOnMobile
}) => (
    <div className="error-container" style={{ height: 100 + 'vh' }}>
        <div className="error-block">
            <div className="error-block__logo">
                <Logo />
            </div>
            <div className="error-block__content">
                <img
                    src={`${STATIC_STORAGE_URL}/img/no-mobile.gif`}
                    style={{ maxWidth: '200px', margin: '0 auto' }}
                />
                <span className="error-block__title">
                    For your best experience, this page does not currently
                    support smaller screens and mobile devices.
                </span>
                <p className="error-block__text">
                    Please try again on a larger device.
                </p>
            </div>
            <Link
                exact
                to={WORKSPACE}
                onClick={() => toggleIsSupportedOnMobile(false)}
            >
                <button className="btn btn--md btn--blue mr-2">Home</button>
            </Link>
        </div>
    </div>
);
export default PageNotSupportedOnMobile;
